import { MemberResult } from 'src/models/autocomplete.model';
import { FormattedStringParams, FormattedStringTypes } from 'src/tools/string.tools';

export const MEMBERS_ADD_MESSAGE_PARAMS: FormattedStringParams[] = [
  {
    id: 1,
    type: FormattedStringTypes.LINK,
    payload: 'https://www.google.com',
  },
];

export const INVITE_BUTTON: MemberResult = {
  id: 'invite',
  label: '',
  name: '',
  email: '',
  company: '',
  already_assigned: false,
};
